import Component from "./surveys.component";
import { Config } from "./surveys.config";
import { watchSurveys as saga } from "./redux/surveys.sagas";
import { reducer } from "./redux/surveys.reducer";

export default { Component, saga, reducer, config: Config };
